export default __webpack_public_path__ + "locales/pt-BR/Common.json?hash=ca5bb22376f2d33d0f8cc4c79ec5f92a";